import styled from '@emotion/styled';
import { Table, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { FiRefreshCcw } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import { ConnectedUserEntity } from '../../../../../entities/ConnectedUserEntity';
import { BondEntity } from '../../../../../entities/bond.entity';
import { FavorisEntity } from '../../../../../entities/favoris.entity';
import { PRIMARY, YELLOW } from '../../../../../shared/colors';
import { dateFormatterNoTime } from '../../../../shared/Table/cellFormatter';
import { getUserFavoris } from '../../../network';

const Container = styled.div`
  color: white;
  padding: 5px;
  margin-bottom: 5px;
  font-family: Poppins-R;

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #757575;
    color: white;
  }
`;

export const Favoris = ({
  getBond,
}: {
  getBond: (b: BondEntity, ope: '1' | '2') => void;
}) => {
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [favoris, setFavoris] = useState<FavorisEntity[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchData = () => {
    setIsLoading(true);
    getUserFavoris(connectedUser.id).then(({ data }) => {
      setFavoris(data);
      setIsLoading(false);
    });
  };

  return (
    <Container>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          paddingRight: 10,
        }}
      >
        <div style={{ marginRight: 150 }}>
          <PulseLoader size={5} margin={2} color={YELLOW} loading={isLoading} />
        </div>
        <Tooltip title='Rafraichir' placement='leftTop' color={YELLOW}>
          <span style={{ cursor: 'pointer' }} onClick={fetchData}>
            <FiRefreshCcw />
          </span>
        </Tooltip>
      </div>
      {favoris.length === 0 ? (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          Aucun favoris disponible ...
        </div>
      ) : (
        <Table
          columns={COLUMNS}
          dataSource={favoris}
          rowSelection={{
            type: 'radio',
            onChange: (selectedRowKeys, selectedRows) => {
              getBond(selectedRows[0].bond, '1');
            },
          }}
          rowClassName={(row, index) =>
            index % 2 === 0 ? 'even-row' : 'odd-row'
          }
          rowKey='id'
          size='small'
          style={{ zoom: 0.8 }}
          pagination={false}
          showSorterTooltip={false}
        />
      )}
    </Container>
  );
};

const COLUMNS = [
  {
    title: 'Pays',
    render: (cell: any, row: FavorisEntity) => row.bond.pays,
    sorter: (a: FavorisEntity, b: FavorisEntity) =>
      a.bond.pays.localeCompare(b.bond.pays),
  },
  {
    title: 'Type',
    render: (cell: any, row: FavorisEntity) => row.bond.instrument,
    sorter: (a: FavorisEntity, b: FavorisEntity) =>
      a.bond.instrument.localeCompare(b.bond.instrument),
  },
  {
    title: 'CODE',
    sorter: (a: FavorisEntity, b: FavorisEntity) =>
      a.bond.code.localeCompare(b.bond.code),
    render: (cell: any, row: FavorisEntity) => (
      <div
        style={{
          width: 120,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        {row.bond.code}
      </div>
    ),
  },
  {
    title: 'Date de maturation',
    render: (cell: any, row: FavorisEntity) => row.bond.dateMaturite,
    sorter: (a: FavorisEntity, b: FavorisEntity) =>
      a.bond.dateMaturite.localeCompare(b.bond.dateMaturite),
  },
  {
    title: 'Coupon',
    dataIndex: 'tauxMarginal',
    sorter: (a: FavorisEntity, b: FavorisEntity) =>
      a.bond.tauxMarginal - b.bond.tauxMarginal,
    render: (cell: any, row: FavorisEntity) => (
      <>{Number(row.bond.tauxMarginal)}</>
    ),
  },
  {
    title: 'Date ajout',
    dataIndex: 'created_at',
    render: dateFormatterNoTime,
    sorter: (a: FavorisEntity, b: FavorisEntity) =>
      a.created_at.localeCompare(b.created_at),
  },
];
